module.exports = __webpack_public_path__ + "img/9788964961506.a46aecbe.jpg";